import environment from '$lib/environment'

export const getCookiekey = (key: string): string => {
	if (key.substring(0, 4) === 'inv-') return environment.cookiePrefix + '-' + key

	return key
}

export function getCookieValue(name: string) {
	const regex = new RegExp(`(^| )${name}=([^;]+)`)
	const match = document.cookie.match(regex)
	if (match) {
		return match[2]
	}
}

export function getCookieIncludes(name: string) {
	return document.cookie.includes(name)
}

export function setCookieValue(cName: string, cValue: string, expDays: number) {
	const date = new Date()
	date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000))
	const expires = 'expires=' + date.toUTCString()
	document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/'
}
